<template>
	<div class="contact-wrapper">
		<Mail class="illustration" />
		<a href="mailto:selimialtin@gmail.com?subject=Mail from altinselimi" ref="emailMeRef">Click here to open your Mail app.</a>  
	</div>
</template>
<script>
import Mail from '@/assets/mail.vue';
export default {
	components: {
		Mail,
	},
	data: () => ({
		done: null
	})
}
</script>
<style lang="scss">
.contact-wrapper {
	padding: 20px;
	padding-bottom: 44px;
	min-height: 60vh;
	display: flex;
	flex-direction: column;
	a {
		font-size: 4rem;
		color: var(--dark-shade);
		text-decoration: none;
		text-align: center;
		margin: 0 auto;
		margin-top: 20px;
		cursor: pointer;
		border-radius: 5px;
		padding: 8px 12px;
		box-shadow: 0px 0px 3px -1px rgba(black, .4);
		@media screen and (min-width: 550px) {
			font-size: 1.5rem;
		}
	}
}

.illustration {
	margin: 20px auto;
	max-width: 250px;
}
</style>